import {
  FileDataApiGetPiiBySourceRequest,
  PageDocumentClassificationInfo,
  PageFileDataDetailed,
  PageFileMetaDataInfo,
  PageSensitiveDataInfo,
  PageResourcesRead,
  ResourcesApiGetResourcesByGroupRequest,
  SourceSensitiveData,
  VisibilityDataApiGetDocumentClassificationBySubtypesSourceAndObjectsRequest,
  VisibilityDataApiGetFileMetadataInfoRequest,
  VisibilityDataApiGetSensitiveDataInfoTableRequest,
  VisibilityDataApiGetSourceSensitiveDataRequest,
} from '@ariksa/data-scanning/api';

import { DataScanningService } from 'api/services';
import { useAriksaQuery } from 'utils/query/useAriksaQuery';

export function useDataScanningService() {
  const piiBySource = useAriksaQuery<
    FileDataApiGetPiiBySourceRequest,
    PageFileDataDetailed
  >({
    queryKey: [],
    fetcher: req =>
      DataScanningService.FileData.getPiiBySource(req).then(r => r.data),
  });

  const fileMetadataInfo = useAriksaQuery<
    VisibilityDataApiGetFileMetadataInfoRequest,
    PageFileMetaDataInfo
  >({
    queryKey: [],
    fetcher: req =>
      DataScanningService.Visibility.getFileMetadataInfo(req).then(r => r.data),
  });

  const dataSourceSensitiveInfo = useAriksaQuery<
    VisibilityDataApiGetSourceSensitiveDataRequest,
    SourceSensitiveData
  >({
    queryKey: [],
    fetcher: req =>
      DataScanningService.Visibility.getSourceSensitiveData(req).then(
        r => r.data,
      ),
  });

  const sensitiveDataInfoTable = useAriksaQuery<
    VisibilityDataApiGetSensitiveDataInfoTableRequest,
    PageSensitiveDataInfo
  >({
    queryKey: [],
    fetcher: req =>
      DataScanningService.Visibility.getSensitiveDataInfoTable(req).then(
        r => r.data,
      ),
  });

  const documentClassificationFileObject = useAriksaQuery<
    VisibilityDataApiGetDocumentClassificationBySubtypesSourceAndObjectsRequest,
    PageDocumentClassificationInfo
  >({
    queryKey: [],
    fetcher: req =>
      DataScanningService.Visibility.getDocumentClassificationBySubtypesSourceAndObjects(
        req,
      ).then(r => r.data),
  });

  const resourcesByGroup = useAriksaQuery<
    ResourcesApiGetResourcesByGroupRequest,
    PageResourcesRead
  >({
    queryKey: [],
    fetcher: req =>
      DataScanningService.Resources.getResourcesByGroup(req).then(r => r.data),
  });

  return {
    piiBySource,
    dataSourceSensitiveInfo,
    sensitiveDataInfoTable,
    fileMetadataInfo,
    documentClassificationFileObject,
    resourcesByGroup,
  };
}
